import React from 'react';

const Loader = ({ size = 'medium', color, label = "Loading" }) => {
  const sizeClasses = {
    xs: 'loader--xs',
    small: 'loader--small',
    medium: 'loader--medium',
    large: 'loader--large'
  };

  const colorClass = color ? `loader--${color}` : '';

  return (
    <div className={`modern-loader ${sizeClasses[size] || sizeClasses.medium} ${colorClass}`}>
      <div className="modern-loader__spinner">
        <svg viewBox="0 0 50 50" className="modern-loader__svg">
          <circle
            className="modern-loader__track"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            strokeWidth="4"
          />
          <circle
            className="modern-loader__progress"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            strokeWidth="4"
            strokeLinecap="round"
          />
        </svg>
      </div>
      {size !== 'xs' && label && <span className="modern-loader__label">{label}</span>}
    </div>
  );
};

export default Loader;
